module.exports = __webpack_public_path__ + "media/images/investor-independence-619fd2f5.png";